<svg width="2.4rem" height="2.4rem" class="svg-icon" [class.clear]="parentSize()" [class.limit-size]="limitSize()">
  <use [attr.href]="'#' + name()"></use>
</svg>
